import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Subject, Subscription } from "rxjs/Rx";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { debounceTime } from "rxjs/operator/debounceTime";
import { AccountService } from "../../shared/account/account.service";
import * as firebase from "firebase/app";
import { BackendService } from "../../shared/services/backend.service";
import { AuthService } from "../../shared/services/auth.service";
import { CommunityService } from "../../shared/services/community/community.service";
import { FileUploadService } from "../../shared/services/fileuploadservice";
import { Community } from "../../shared/services/community/community";
import { CountryService } from "../../shared/location/country.service";
import { StateService } from "../../shared/location/state.service";
import { CityService } from "../../shared/location/city.service";
@Component({
  selector: "app-community-resources",
  templateUrl: "./community-resources.component.html",
  styleUrls: ["./community-resources.component.css"]
})
export class CommunityResourcesComponent implements OnInit, OnDestroy {
  private _alert: Subject<string> = new Subject<string>();
  private alertSubscription: Subscription = new Subscription();
  activeRouteIndex: number;
  routeSubscription: Subscription;
  community: Community;
  components: any;
  confirmationMessage = "";
  confirmationTitle = "";
  modalReference: NgbModalRef;
  successMessage = "";
  errorMessage = "";
  LGAs = [];
  private authState: firebase.User | null;
  private userId: string;
  private roleSubscription: Subscription;
  isReadOnly = false;
  hasNoName = false;
  hasNoStreet = false;
  hasNoSubAccountCode = false;
  private uploadedAvatarURL$;
  private uploadedAvatarURLSubscription;
  query = "";
  actionType: string;
  propertiesCount$;

  defaultCountry = "NG";
  countryCode: string;
  countries = [];
  states = [];
  cities = [];
  selectedStateId: string;
  selectedCountryCode: string;
  stateIdOnInit = "";
  atCount: number;
  cmCount: number;
  user: any;

  constructor(
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private router: Router,
    private accountService: AccountService,
    private authService: AuthService,
    private communityService: CommunityService,
    private uploadService: FileUploadService,
    private countryService: CountryService,
    private stateService: StateService,
    private cityService: CityService
  ) {
    this.authState = this.authService.getAuthState();
    this.userId = BackendService.generateUserId(
      this.authState.email
    );
  }

  ngOnInit(): void {
    this.routeSubscription = this.route.params.subscribe(params => {
      this.activeRouteIndex = params.index;
      this.propertiesCount$ = this.communityService
        .checkIfPropertiesExist(params.communityId);

      this.communityService
        .getEmailsOfAccessTerminalPersonnels(params.communityId)
        .subscribe(data => {
          this.atCount = data ? Object.keys(data).length : 0;
        });

      this.communityService
        .getEmailsOfCommunityManagers(params.communityId)
        .subscribe(data => {
          this.cmCount = data ? Object.keys(data).length : 0;
        });

      this.communityService
        .getCommunityById(params.communityId)
        .subscribe(community => {
          this.community = community;

          const { countryCode, lgaId, stateId } = community.location.address;
          this.stateService.getStateById(countryCode, stateId).subscribe(data => {
            this.community.location.address.stateName = data;
          });

          this.cityService.getCityById(countryCode, stateId, lgaId).subscribe(data => {
            this.community.location.address.lgaName = data;
          });

          if (this.community && this.community.id) {
            this.stateIdOnInit = this.community.location.address.stateId;
            this.selectedCountryCode = this.community.location.address.countryCode;
            this.fetchStatesOnCountryChange(this.community.location.address.countryCode, true);
            this.fetchCitiesOnStateChange(this.community.location.address.stateId);
          }
        });
    });
    this.components = {
      communityManager: true,
      accessTerminal: false,
      shiftsTab: false
    };
    this.roleSubscription = this.accountService
      .getProfile(this.userId)
      .subscribe((profile: any) => {
        this.user = profile;
        this.route.params.subscribe(params => {
          const activeRole: any = profile.roles[params.index];
          this.setReadOnly(activeRole.role);
        });
      });

    this.countryService.getCountries().subscribe(countries => {
      if (countries) {
        this.countries = [];
        countries.forEach(country => {
          this.countries.push({ code: country.iso_3166_1_alpha2, name: country.name.common });
        });
      }
    }
    );
  }

  ngOnDestroy(): void {
    this.closeModal();
    this.routeSubscription.unsubscribe();
    this.roleSubscription.unsubscribe();
    this.uploadedAvatarURLSubscription
      ? this.uploadedAvatarURLSubscription.unsubscribe()
      : null;
  }

  openImageUploader(): void {
    const element = document.getElementById("imageUploader") as HTMLElement;
    element.click();
  }

  showAlert(msgType, msg): void {
    this.alertSubscription = this._alert.subscribe(
      message =>
        msgType
          ? (this.successMessage = message)
          : (this.errorMessage = message)
    );
    debounceTime
      .call(this._alert, 3000)
      .subscribe(
        () =>
          msgType
            ? (this.successMessage = undefined)
            : (this.errorMessage = undefined)
      );
    this._alert.next(msg);
    this.alertSubscription.unsubscribe();
  }

  showComponent(component): void {
    const componentNames = Object.keys(this.components);
    componentNames.forEach(el => {
      if (el === component) {
        this.components[el] = true;
      } else {
        this.components[el] = false;
      }
    });
  }

  openModal(modal, modalSize): void {
    if (!modalSize) {
      this.modalReference = this.modalService.open(modal);
    } else {
      this.modalReference = this.modalService.open(modal, { size: modalSize });
    }
  }

  closeModal(): void {
    if (this.modalReference) {
      this.modalReference.close();
    }
  }

  confirmDelete(community: any, modal): void {
    const message = `Are you sure you want to delete ${community.name}?`;
    this.confirm("Delete Community!", message, modal);
  }

  confirm(title, message, modal): void {
    this.confirmationTitle = title;
    this.confirmationMessage = message;
    this.openModal(modal, "sm");
  }

  deleteCommunity(): void {
    this.communityService.delete(this.community.id);
    this.closeModal();
    this.router.navigate(["/communities/r/", this.activeRouteIndex], {
      queryParams: { isSuccess: true }
    });
  }

  editCommunity(modal): void {
    this.hasNoName = this.hasNoStreet = this.hasNoSubAccountCode = false;
    this.openModal(modal, null);
  }

  confirmAction(type, community: any, modal, event: any): void {
    this.community = community;
    this.actionType = type;
    const message = `Are you sure you want to ${type} "${this.community.name}"`;
    this.confirm("Attention!", message, modal);
  }

  deactivateCommunity(): void {
    this.communityService.deactivate(this.community.id);
    this.closeModal();
    this.showAlert(true, "Community deactivated successfully.");
  }

  activateCommunity(): void {
    this.communityService.activate(this.community.id);
    this.closeModal();
    this.showAlert(true, "Community activated successfully.");
  }

  saveCommunity(): void {
    this.community.name = this.community.name.trim();
    this.community.location.address.street = this.community.location.address.street.trim();

    if (!this.community.name) {
      this.hasNoName = true;

      return;
    }

    if (!this.community.location.address.street) {
      this.hasNoStreet = true;

      return;
    }

    if (!this.community.subAccountCode) {
      this.hasNoSubAccountCode = true;

      return;
    }

    if (!this.community.location.address.countryCode || !this.community.location.address.stateId
       || !this.community.location.address.lgaId) {
      alert("Please fill in all required fields.");

      return ;
    }

    try {
      this.communityService.update(this.community);
      this.closeModal();
      this.showAlert(true, "Community updated successfully.");
    } catch (e) {
      console.log(e);
    }
  }

  setReadOnly(role: string): void {
    this.isReadOnly = role.toLowerCase() == "community manager";
  }

  setCity(cityId: string): void {
    this.community.location.address.lgaId = cityId;
  }

  uploadImage(event): void {
    const file = event.target.files[0];
    this.uploadedAvatarURL$ = this.uploadService.upload("avatars", file);
    this.uploadedAvatarURLSubscription = this.uploadedAvatarURL$.subscribe(
      data => {
        this.community.avatar = data;
      }
    );
  }

  fetchStatesOnCountryChange(countryCode: string, onInit: boolean = false) {
    this.states = [];
    this.cities = [];
    !onInit ? this.community.location.address.stateId = "" : "";
    if (countryCode) {
      this.community.location.address.countryCode = countryCode;
      this.stateService.getCountryStates(countryCode)
        .subscribe(states => {
          if (states) {
            const keys = Object.keys(states);
            keys.forEach(key => {
              this.states.push({ id: key, name: states[key] });
            });
          }
        });
    }
  }

  fetchCitiesOnStateChange(stateId: string) {
    this.cities = [];
    this.selectedStateId = stateId;
    if (this.selectedStateId) {
      this.community.location.address.stateId = stateId;
      const countryCode = this.community.location.address.countryCode;

      this.cityService.getStateCities(countryCode, stateId)
        .subscribe(countrySnap => {
          if (countrySnap) {
            if (stateId) {
              const stateSnap = countrySnap;
              const stateKeys = Object.keys(stateSnap);
              stateKeys.forEach(key => {
                this.cities.push({ id: key, name: stateSnap[key] });
              });
            }
          }
        });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/community-management/community-resources/community-resources.component.ts